import { produce } from "immer";
import { Store } from "reducers/rootReducer";


/* STATE */
type State = {
  visible: boolean;
  collapse: boolean;
  visibleBurger: boolean;
}

const initialState: State = {
  visible: true,
  collapse: false,
  visibleBurger: true,
}    

/* ACTIONS */
const SHOW_NAV_HEADER = "SHOW_NAV_HEADER";
const HIDE_NAV_HEADER = "HIDE_NAV_HEADER";
const COLLAPSE_NAV_HEADER = "COLLAPSE_NAV_HEADER";
const HIDE_NAV_BURGER = "HIDE_NAV_BURGER";
const SHOW_NAV_BURGER = "SHOW_NAV_BURGER";

type Action =
| { type: typeof SHOW_NAV_HEADER }
| { type: typeof COLLAPSE_NAV_HEADER }
| { type: typeof HIDE_NAV_HEADER }
| { type: typeof HIDE_NAV_BURGER }
| { type: typeof SHOW_NAV_BURGER }

/* REDUCER */
export default function reducer(state = initialState, action: Action): State {
  return produce(state, draft => {
    switch (action.type) {

      case COLLAPSE_NAV_HEADER:
        if (state.collapse === true) {   
          draft.collapse = false;
        } else {
          draft.collapse = true;  
        }
        break;
      case HIDE_NAV_HEADER:
          draft.visible = false;
          break;
      case HIDE_NAV_BURGER:
          draft.visibleBurger = false;
          break;
      case SHOW_NAV_BURGER:
          draft.visibleBurger = true;
          break;
      default:
        draft.visible = true;
      break;
    }
  })
}

/* ACTION CREATORS */
export const showNavHeader = (): Action => ({
  type: SHOW_NAV_HEADER,
});

export const hideNavHeader = (): Action => ({
  type: HIDE_NAV_HEADER,
});

export const hideBurger = (): Action => ({
  type: HIDE_NAV_BURGER,
});

export const showBurger = (): Action => ({
  type: SHOW_NAV_BURGER,
});
export const collapseNavHeader = (): Action => ({
  type: COLLAPSE_NAV_HEADER,
});

/* SELECTORS */
export const selectCollapse = (app: Store) => app.navHeader.visible;
export const selectNavVisible = (app: Store) => app.navHeader.visible;
export const selectBurgerVisible = (app: Store) => app.navHeader.visibleBurger;
